(function () {
  function initSizeChart(root) {
    if (!root || root.dataset.sizeChartReady === 'true') return;
    root.dataset.sizeChartReady = 'true';

    var tabs = root.querySelectorAll('[data-region]');
    var panels = root.querySelectorAll('[data-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var region = tab.getAttribute('data-region');

        tabs.forEach(function (item) {
          var isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-panel') === region;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-size-chart]').forEach(initSizeChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
